import React from 'react';
import {SimpleDialog} from "@components/form/SimpleDialog";
import {Input} from '@components/form/Input';
import {StyledMessageComponent} from "@components/common/messages/StyledMessageComponent";
import Button from "@material-ui/core/Button";
import clsx from "clsx";

export class TaskReportComponent extends React.Component {
    state = {
        open: false,
        form: {
            report: ''
        },
        errors: {}
    }

    saveReport = async () => {
        let response = await this.props.changeUserTaskStatus(this.props.taskId, this.state.form);

        if (response.errors && Object.keys(response.errors).length) {
            this.setState({errors: response.errors});
        } else {
            this.setState({open: false});
            if (this.props.onStatusChange) {
                this.props.onStatusChange(response.data);
            } else {
                history.go();
            }
        }
    }

    render() {
        let { openIcon, report, is_report_required, classes } = this.props;

        if (report) {
            return report;
        }

        if (!!!is_report_required) {
            return <span onClick={e => this.saveReport()}>
                {openIcon}
            </span>
        }

        return (<SimpleDialog
            fullWidth={true}
            maxWidth={'sm'}
            open={this.state.open}
            onClose={(e) => this.setState({open: false})}
            title={'Создание отчета по задаче'}
            icon={<span onClick={e => this.setState({open: true})}>
                {openIcon}
            </span>}
            actions={[
                (<Button
                    onClick={(e) => this.saveReport()}
                    color="primary" variant="contained"
                >
                    Сохранить
                </Button>),
            ]}
        >
            <StyledMessageComponent
                message={'Для закрытия данной задачи необходимо заполнить отчет.'}
            />

            <Input
                name={'report'}
                label={'Текст отчета'}
                value={this.state.form.report}
                className={clsx([classes.input, classes.resetMarginBottom])}
                onChange={({target: {value}}) => this.setState({
                    ...this.state,
                    form: {...this.state.form, report: value}
                })}
                errors={this.state.errors}
                fullWidth
                variant={'outlined'}
                margin={'normal'}
                size={'small'}
                multiline
                rows={4}
            />
        </SimpleDialog>);
    }
}
